module.exports = __webpack_public_path__ + "img/checklist.dfbd52dd.svg";